import React from "react";
import './ImageLinkForm.css';

const ImageLinkForm = ({ onInputChange, onPictureSubmit }) => {
    return (
        <div>
            <p className="f3">
                {'This Magic Brain will detect faces in your pictures. Give it a try.'}
            </p>
            <div className="center">
                <div className='form pa4 br3 shadow-5'>
                    <input className="f4 pa2 w-70 center" type="text" onChange={onInputChange} />
                    <button
                        onClick={onPictureSubmit}
                        className="w-30 grow f4 pv2 link ph3 dib white bg-purple">Detect</button>

                </div>
            </div>
        </div>
    )
}

export default ImageLinkForm;